/* eslint-disable */
<template>
  <div class="bookings-awaiting-dictation">
    <AdminNavigation ref="navigation" indexProps="0"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Bookings Awaiting Dictation</h1></div>
        <div class="header-sub-title">The following bookings are awaiting dictation.</div>
      </div>
    </div>
    <div class="panel no-sub-menu">
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name"
                        v-model="listParam.ClientName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Contact Name"
                        v-model="listParam.ContactName"/>
              <el-select @change="selectPage(1)" placeholder="Booking Status" style="max-width: 200px" class="mr-1"
                         v-model="listParam.BookingStatus" filterable clearable>
                <el-option v-for="item in bookingStatuses" :key="item.id" :value="item.id" :label="item.name">
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <el-table ref="bookingTable"
                        :default-sort="{prop: 'BookingID', order: 'descending'}" stripe @sort-change="sortParam"
                        :data="bookings" tooltip-effect="dark"
                        :header-row-style="{background: '#fde9eb', height: '70px'}"
                        :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="100"
                    prop="BookingID"
                    label="ID"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="booking">
                    <router-link :to="{ name: 'admin-manage-client', query: { id: booking.row.Case.ClientId } }">
                      {{ decodeURIComponent(booking.row.Case.Client.ClientName) }} -
                      {{ decodeURIComponent(booking.row.Case.Client.BranchName) }}
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    sortable="custom"
                    prop="ClientContact"
                    label="Contact">
                  <template slot-scope="booking">
                    <router-link
                        :to="{ name: 'admin-manage-client', query: { id: booking.row.Case.ClientId, type: 'edit-contact' } }">
                      {{booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + booking.row.ClientContact.MiddleName + ' ' + booking.row.ClientContact.Surname) }}
                    </router-link>
                  </template>
                  >
                </el-table-column>
                <el-table-column
                    sortable="custom"
                    show-overflow-tooltip
                    label="Examinee"
                    prop="ClaimantFullName"
                >
                  <template slot-scope="booking">
                    <router-link :to="{ name: 'admin-manage-case', query: { id: booking.row.Case.CaseID } }">
                      {{ decodeURIComponent(booking.row.Case.ClaimantFullName) }}
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="BookingDateTime"
                    sortable="custom"
                    label="Booking Date"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.BookingDateTime, "DD/MM/YYYY HH:mm")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="160"
                    sortable="custom"
                    show-overflow-tooltip
                    prop="BookingStatus"
                    label="Booking Status"
                >
                  <template slot-scope="booking">
                    <span>{{ booking.row.Status.StatusDescription }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="160"
                    sortable="custom"
                    show-overflow-tooltip
                    prop="BookingStatus"
                    label="Tracking Status"
                >
                  <template slot-scope="booking">
                    <span>{{ booking.row.BookingTrackingStatus }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="100"
                    show-overflow-tooltip
                    label=""
                    prop="ZohoLink"
                >
                  <template slot-scope="booking">
                    <div class="is-icon">
                      <a :href="booking.row.ZohoLink" target="_blank">
                        <img src="@/assets/images/zoho_icon.svg"
                                                                       data-placement="right" data-toggle="tooltip"
                                                                       title="Link to Zoho"/></a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import Header from "@/components/Header"
import {debounce} from 'lodash';

export default {
  name: "AdminBookingsAwaitingDictation",
  components: {
    AdminNavigation,
    Header,
  },
  data() {
    return {
      bookings: [],
      allBookings: [],
      limit: 10,
      pagination: utilities.initPagination(),

      byClient: false,
      byContact: false,
      byClaimant: false,
      byDate: false,
      byBookingStatus: false,
      byTrackingStatus: false,
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'BookingID',
        ascOrDesc: 'DESC',
        ClientName: '',
        SpecialistName: '',
        ContactName: '',
        BookingTrackingStatus: utilities.AWAITING_DICTATION
      },
      bookingStatuses: [],
    }
  },
  computed: {},
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    RowClick(row) {
      this.editBooking(row?.BookingID)
    },
    editBooking(bookingId) {
      this.$router.push({path: '/admin-manage-booking', query: {id: bookingId}}).catch((err) => {
      })
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadBookings()
    },
    sortParam(v) {
      this.listParam.orderBy = v.prop
      if (v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    formatDate(dateToFormat, newFormat, currentFormat = "YYYY-MM-DD") {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },
    getBookingStatus(id) {
      return utilities.getBookingStatus(id)
    },

    async loadBookings() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      var {bookings, total} = await utilities.getAllBookingsNew(obj)
      this.bookings = _.cloneDeep(bookings)
      this.totalCount = total
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
    async loadData() {
      this.bookingStatuses = utilities.getBookingStatuses()
    },
  },
  async beforeMount() {
    $('body>.tooltip').remove()
    await this.loadBookings()
    await this.loadData()
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
